export class MessageSearchModel {
	fromMessageId: number;
  tableName: string;
}
